import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './BetaAnnualModal.module.scss';

const BetaAnnualModal = ({ onClose, planName, ...extra }) => {
  const { t } = useTranslation();
  return (
    <SalonModal tag="BetaAnnualModal" {...extra}>
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.modalImage}>
          <div className={CN.iconContainer}>
            <Icon variant="alert" />
          </div>
        </div>
        <div className={CN.modalContent}>
          <div className={CN.modalTitle}>{t('composite.betaAnnualModal.title', { planName })}</div>
          <span className={CN.modalText}>{t('composite.betaAnnualModal.description', { planName })}</span>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="primaryForce" onClick={onClose}>
          <span className={CN.buttonSpace}>{t('composite.betaAnnualModal.confirm')}</span>
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default BetaAnnualModal;
